"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadingTheme = exports.exampleOemTheme = exports.CarvanaTheme = exports.CarvanaThemeDeprecated = exports.withOpacity = exports.getMediaQuery = exports.createGlobalStyle = exports.HeaderReset = exports.Reset = exports.FontSizes = exports.Font = exports.ThemeProvider = void 0;

var ThemeProvider_1 = require("./ThemeProvider");

Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return ThemeProvider_1.ThemeProvider;
  }
});
Object.defineProperty(exports, "CarvanaThemeDeprecated", {
  enumerable: true,
  get: function () {
    return ThemeProvider_1.CarvanaThemeDeprecated;
  }
});
Object.defineProperty(exports, "CarvanaTheme", {
  enumerable: true,
  get: function () {
    return ThemeProvider_1.CarvanaTheme;
  }
});
Object.defineProperty(exports, "exampleOemTheme", {
  enumerable: true,
  get: function () {
    return ThemeProvider_1.exampleOemTheme;
  }
});
Object.defineProperty(exports, "loadingTheme", {
  enumerable: true,
  get: function () {
    return ThemeProvider_1.loadingTheme;
  }
});
Object.defineProperty(exports, "FontSizes", {
  enumerable: true,
  get: function () {
    return ThemeProvider_1.FontSizes;
  }
});

var Font_1 = __importDefault(require("./Font"));

exports.Font = Font_1.default;

var GlobalStyle_1 = __importDefault(require("./GlobalStyle"));

exports.createGlobalStyle = GlobalStyle_1.default;

var Reset_1 = __importStar(require("./Reset"));

exports.Reset = Reset_1.default;
Object.defineProperty(exports, "HeaderReset", {
  enumerable: true,
  get: function () {
    return Reset_1.HeaderReset;
  }
});

var ThemeUtilities_1 = require("./ThemeUtilities");

Object.defineProperty(exports, "getMediaQuery", {
  enumerable: true,
  get: function () {
    return ThemeUtilities_1.getMediaQuery;
  }
});
Object.defineProperty(exports, "withOpacity", {
  enumerable: true,
  get: function () {
    return ThemeUtilities_1.withOpacity;
  }
});
exports.default = ThemeProvider_1.ThemeProvider;